import {h, Fragment} from "preact"
import { useEffect } from 'preact/hooks';

export default () => {

    useEffect(() => {
        if (window.nostojs) {
            // dynamically load recommendations
            nostojs(api => api.loadRecommendations());
        }
    });

    return (
        <div class="no-results-container">
            <h5 class='text-center py-3'>We're sorry, we cannot find any results for the filters you've selected.</h5>
            <div class="nosto_element" id="no-results-target"></div>
        </div>
    )
}
